import script from "./share.vue?vue&type=script&setup=true&lang=js"
export * from "./share.vue?vue&type=script&setup=true&lang=js"

import "./share.vue?vue&type=style&index=0&id=6f86d68f&lang=scss"
import "./share.vue?vue&type=style&index=1&id=6f86d68f&lang=scss&scoped=true"

import exportComponent from "D:\\WorkPlace\\MINE\\dataleading3.0\\app\\app-web\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6f86d68f"]])

export default __exports__